import { Component, AfterViewInit, OnDestroy, ViewEncapsulation, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as L from 'leaflet';

import { SharedUtilsService } from 'src/app/core/services/shared-utils.service';


@Component({
  selector: 'app-map-dialog',
  templateUrl: './map-dialog.component.html',
  styleUrls: ['./map-dialog.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class MapDialogComponent implements AfterViewInit, OnDestroy {
  map: L.Map | null = null;
  marker: L.Marker | null = null;
  selectedLat: number | null = null;
  selectedLng: number | null = null;
  geolocating = false;
  geolocationMessage = '';

  constructor(
    public dialogRef: MatDialogRef<MapDialogComponent>
    , @Inject(MAT_DIALOG_DATA) public data: any
    , public sharedUtilsService: SharedUtilsService
  ) {

  }

  ngAfterViewInit(): void {
    this.initMap();
    // Corrige les rendus tronqués lors de l'ouverture du dialog.
    setTimeout(() => this.map?.invalidateSize(), 120);
  }

  ngOnDestroy(): void {
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  }
 

  closeMap() {
    this.dialogRef.close(null);
  }

  validate() {
    if (!this.marker) {
      this.dialogRef.close(null);
      return;
    }
    const coords = this.marker.getLatLng();
    const lat = Number(coords.lat.toFixed(6));
    const lng = Number(coords.lng.toFixed(6));
    this.dialogRef.close({
      lat,
      lng,
      address: `Lat: ${lat}, Lng: ${lng}`,
      coordinatesText: `Lat: ${lat}, Lng: ${lng}`
    });
  }

  locateMe(): void {
    if (!navigator.geolocation || !this.map || !this.marker || this.geolocating) {
      this.geolocationMessage = 'La géolocalisation n’est pas disponible sur cet appareil.';
      return;
    }
    this.geolocating = true;
    this.geolocationMessage = '';
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;
        const next = L.latLng(lat, lng);
        this.marker?.setLatLng(next);
        this.map?.setView(next, 15, { animate: true });
        this.updateSelection(lat, lng);
        this.geolocating = false;
      },
      () => {
        this.geolocationMessage = 'Impossible de récupérer votre position. Vérifiez les permissions GPS.';
        this.geolocating = false;
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  }

  private initMap() {
    if (this.map) {
      this.map.remove();
    }
    const lat = this.sharedUtilsService.latitude || 5.3364;
    const lng = this.sharedUtilsService.longitude || -4.0267;
    this.map = L.map('mapid').setView([lat, lng], 13);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap contributors'
    }).addTo(this.map);
    delete (L.Icon.Default.prototype as any)._getIconUrl;
    L.Icon.Default.mergeOptions({
      iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
      iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
      shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png'
    });
    this.marker = L.marker([lat, lng], { draggable: true }).addTo(this.map);
    this.updateSelection(lat, lng);
    this.marker.on('dragend', () => {
      if (!this.marker) return;
      const pos = this.marker.getLatLng();
      this.updateSelection(pos.lat, pos.lng);
    });
    this.map.on('click', (e: L.LeafletMouseEvent) => {
      if (!this.marker) return;
      this.marker.setLatLng(e.latlng);
      this.updateSelection(e.latlng.lat, e.latlng.lng);
    });
  }

  private updateSelection(lat: number, lng: number): void {
    this.sharedUtilsService.latitude = lat;
    this.sharedUtilsService.longitude = lng;
    this.selectedLat = Number(lat.toFixed(6));
    this.selectedLng = Number(lng.toFixed(6));
  }

  get coordinatesLabel(): string {
    if (this.selectedLat == null || this.selectedLng == null) {
      return 'Cliquez sur la carte pour choisir un point';
    }
    return `Lat: ${this.selectedLat}, Lng: ${this.selectedLng}`;
  }

}